import { render, staticRenderFns } from "./SearchTopBarCounter.vue?vue&type=template&id=c8970286&scoped=true&"
import script from "./SearchTopBarCounter.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchTopBarCounter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8970286",
  null
  
)

export default component.exports